import "../pages/CheckIn.css";
import { React, useState,useEffect,useMemo,useRef,forwardRef,useImperativeHandle } from "react";
import DatePicker, { DateObject } from 'react-multi-date-picker';
import {
  Box,
  Chip,
  Stack,
  Paper,
  OutlinedInput,
  Select,
  MenuItem,
  Button,
  Typography,
} from "@mui/material";
import { apiMain } from "../../App";
import { DataGrid  ,GridToolbar   } from '@mui/x-data-grid';
import { useSnackbar } from "notistack";
import { GetDataPromise } from "../Functions/SendingData";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { useReactToPrint } from "react-to-print";
import {  PictureAsPdf, Print } from "@mui/icons-material";
import ExcelIcon from "../images/IconExcel";
import ExcelJS from "exceljs";





//const paginationModel = { page: 0, pageSize: 5 };

const BookingReport=forwardRef((props,ref)=>{
    // const { item, applyValue } = props;
    const [DolerLary,setDolerLary] = useState('$');
    const columns = useMemo(() => [
        { field: 'id', headerName: 'ID', width: 90   ,  editable: false,},
    
          {
        field: 'Name',
        headerName: 'Name ',
      //  description: 'This column has a value getter and is not sortable.',
        sortable: true,
        width: 150,
        editable: false,
        
        // valueGetter: (value, row) => `${row.firstName || ''} ${row.lastName || ''}`,
      },
      {
        field: 'Pass_No',
        headerName: 'Passport Number',
      //  description: 'This column has a value getter and is not sortable.',
        sortable: true,
        width: 100,
        editable: false,
        // valueGetter: (value, row) => `${row.firstName || ''} ${row.lastName || ''}`,
      },
    
    
    
    {
      field: 'Room_Number',
      headerName: 'Room Number',
      type: 'text',
      width: 70,
      editable: false,
    },
    
    {
        field: 'Prese_Name',
        headerName: 'type',
        type: 'text',
        width: 80,
        editable: false,
      },
      
      {
        field: 'Reserv_Name',
        headerName: 'Reserv type',
        type: 'text',
        width: 90,
        editable: false,
        cellClassName: (params) => {
          if (params.value === 'Cancel' || params.value === '4') {
            return 'cancel-cell';
          }
          return '';
        }
      },
      
     // { field: 'Reserv_Id', headerName: 'Id', width: 20 },
     {
      field: 'Reserv_Date',
      headerName: 'Reserv Date ',
    //  description: 'This column has a value getter and is not sortable.',
      sortable: true,
      width: 90,
      editable: false,
      
      // valueGetter: (value, row) => `${row.firstName || ''} ${row.lastName || ''}`,
    },
    
      {
        field: 'Reserv_Checkindate',
        headerName: 'Checkin Date',
        type: 'text',
        width: 90,
        editable: false,
      },
    
      {
        field: 'Reserv_Checkoutdate',
        headerName: 'CheckOut Date',
        type: 'text',
        width: 90,
        editable: false,
      },
      {
        field: 'Night_No',
        headerName: 'Night No',
        type: 'text',
        width: 62,
        editable: false,
      },
      {
        field: 'Reserv_Base_Price',
        headerName: `price PerNight ${DolerLary} `,
        type: 'text',
        width: 80,
        editable: false,
      },
    
      {
        field: 'Reserv_Price',
        headerName: `Price Room ${DolerLary}`,
        type: 'text',
        width: 80,
        editable: false,
      },
    
      {
        field: 'Reserv_BreakfastAmount',
        headerName: `Breakfast ${DolerLary}`,
        type: 'text',
        width: 80,
        editable: false,
      },
    
      {
        field: 'Reserv_ExtraAmount',
        headerName: `Extra ${DolerLary}`,
        type: 'text',
        width: 80,
        editable: false,
      },
    
      {
        field: 'Reserv_Other',
        headerName: `Other ${DolerLary}`,
        type: 'text',
        width: 80,
        editable: false,
      },
      {
        field: 'Reserv_Discount',
        headerName: `Discount ${DolerLary}`,
        type: 'text',
        width: 80,
        editable: false,
      },
      {
        field: 'Reserv_Account',
        headerName: `Sum ${DolerLary}`,
        type: 'text',
        width: 80,
        editable: false,
      },
    
    
      {
        field: 'Reserv_prepayment',
        headerName: `prepayment ${DolerLary}`,
        type: 'text',
        width: 80,
        editable: false,
      },
      {
        field: 'Reserv_Total',
        headerName: `Total ${DolerLary}`,
        type: 'text',
        width: 100,
        editable: false,
      },
    
      // {
      //   field: 'Reserv_Rate',
      //   headerName: 'Rate',
      //   type: 'text',
      //   width: 40,
      //   editable: false,
      // },
      // {
      //   field: 'Reserv_Gel',
      //   headerName: 'Total Price₾',
      //   type: 'text',
      //   width: 100,
      //   editable: false,
      // },
    
      {
        field: 'U_Name',
        headerName: 'User',
        type: 'text',
        width: 100,
        editable: false,
      },
    ]
  , [DolerLary]);
    // ستون‌های عددی که می‌خوای جمع بشن
    const numericFields = [
      "Reserv_Base_Price",
      "Reserv_Price",
      "Reserv_BreakfastAmount",
      "Reserv_ExtraAmount",
      "Reserv_Other",
      "Reserv_Account",
      "Reserv_Discount",      // <-- توجه کن که دقیقاً همین نام باشد
      "Reserv_prepayment",
      "Reserv_Total",
      // "Reserv_Rate",
      // "Reserv_Gel"
    ];

    const gridRef = useRef();
    useImperativeHandle(ref, () => ({
      excel: exportToExcel,
      pdf: exportToPDF,
      print: handlePrint,
    }));
  useEffect(() => {
    setFrom_Date(new DateObject());
    let newToDate = new DateObject();
    newToDate.add(10, "day");
    setTo_Date(newToDate);
    getRoomType();
    getPresentType();
    getReserv_Type();
 }, [])
 // محاسبه مجموع

// یک فیلد id بدهیم و یک label برای ردیف جمع
let rowsWithSum = [];
let lastId=0;
let sumRow=0;
 const [Last_Name, setLast_Name] = useState('');
const [prese_Id, setprese_Id] = useState("");
const [Reserv_Type, setReserv_Type] = useState("");

const [PresentTypeData, setPresentTypeData] = useState([]);
const [Reserv_TypeData, setReserv_TypeData] = useState([]);
const [RoomTypeData, setRoomTypeData] = useState([]);
const [Room_No, setRoom_No] = useState(0);
const changeRoom_No = (event) => {
   setRoom_No(event.target.value);
 };
 const getPresentType = async () => {
  let res = await GetDataPromise(`${apiMain}/api/v1/presents`, true);
  let parsed = JSON.parse(res);
  console.log(parsed)
  if (parsed.status === "success") setPresentTypeData(parsed.data);
};
const getReserv_Type = async () => {
  let res = await GetDataPromise(`${apiMain}/api/v1/reservtype`, true);
  let parsed = JSON.parse(res);
  if (parsed.status === "success") setReserv_TypeData(parsed.data);
};
 const getRoomType = async () => {
  let res = await GetDataPromise(`${apiMain}/api/v1/room`, true);
  let parsed = JSON.parse(res);
  if ((parsed.status && parsed.status !== "error") || parsed.status === "success") {
    let newData = parsed.data;
    setRoomTypeData(newData)
  }

}
const getDataLary = async ( ) => {
  setDolerLary("₾");
//  columns[10].headerName= 'price PerNight 000'
  let uparams = new URLSearchParams();
  uparams.append("From_Date", From_Date);
  uparams.append("To_Date", To_Date);
  uparams.append("Pass_LName", Last_Name);
  uparams.append("Room_Number", Room_No);
  uparams.append("prese_Id", prese_Id);
  uparams.append("Reserv_Type", Reserv_Type);
    let res = await GetDataPromise(`${apiMain}/api/v1/reservation/selectglobalreportsLary?${uparams}`, true);
 let parsed = JSON.parse(res);

  if((parsed.status && parsed.status !== "error") || parsed.status === "success"){
      let newData = parsed.data;
   setData(newData)
rowsWithSum = [...newData];
lastId = newData.length ? Math.max(...newData.map(r => r.id)) : 0;

const sumRow = {
  Name: "Total",
  id: Math.max(...newData.map(r => r.Pass_Id || 0)) + 1, // id یکتا عددی
};

numericFields.forEach(field => {
  sumRow[field] = Number(
    newData.reduce((acc, row) => acc + Number(row[field] || 0), 0).toFixed(2)
  );
});

  sumRow.id = lastId + 1; // id یکتا و عددی
sumRow.Name = "Total";
rowsWithSum = [...newData, sumRow];
setData(rowsWithSum)
  }
 else
  {  setData([])}
   getSumData();  



  }
  const getData = async ( ) => {
setDolerLary('$');
    let uparams = new URLSearchParams();
    uparams.append("From_Date", From_Date);
    uparams.append("To_Date", To_Date);
    uparams.append("U_id", localStorage.getItem('U_id'));
   console.log(localStorage.getItem('U_id'))

      let res = await GetDataPromise(`${apiMain}/api/v1/reservation/selectbookingreports?${uparams}`, true);
   let parsed = JSON.parse(res);
 
    if((parsed.status && parsed.status !== "error") || parsed.status === "success"){
        let newData = parsed.data;
        console.log(newData)
   setData(newData)
 rowsWithSum = [...newData];
  lastId = newData.length ? Math.max(...newData.map(r => r.id)) : 0;

  const sumRow = {
    Name: "Total",
    id: Math.max(...newData.map(r => r.Pass_Id || 0)) + 1, // id یکتا عددی
  };
  
  numericFields.forEach(field => {
    sumRow[field] = Number(
      newData.reduce((acc, row) => acc + Number(row[field] || 0), 0).toFixed(2)
    );
  });

    sumRow.id = lastId + 1; // id یکتا و عددی
sumRow.Name = "Total";
 rowsWithSum = [...newData, sumRow];
  setData(rowsWithSum)
    }
   else
    {  setData([])}
     getSumData();  

 

    }

      const getSumData = async ( ) => {
    
        let uparams = new URLSearchParams();
        uparams.append("From_Date", From_Date);
        uparams.append("To_Date", To_Date);
        uparams.append("Pass_LName", Last_Name);
        uparams.append("Room_Number", Room_No);
        uparams.append("prese_Id", prese_Id);
     
    
          let res = await GetDataPromise(`${apiMain}/api/v1/reservation/sumglobalreports?${uparams}`, true);
       let parsed = JSON.parse(res);

        if((parsed.status && parsed.status !== "error") || parsed.status === "success"){
            let newData = parsed.data;
       setSumData(newData)

    //   console.log(newData)
        }
       else
        {  setSumData([])}
           
        }
     


 // const params = useParams()
  const [data, setData] = useState();
  const [sumdata, setSumData] = useState();
//    const { data,loading } = useDemoData({
//     dataSet: 'Commodity',
//     rowLength: 100,
//     maxColumns: 6,
//   });

  const { enqueueSnackbar } = useSnackbar();
  // const [dialogLoading, setDialogLoading] = useState(false);
  // const [dialogError, setDialogError] = useState({});
  //const [Reserv_Id, setReserv_Id] = useState(0);
 	// const [Id, setId] = useState(0);
    const [From_Date, setFrom_Date] = useState();
    const [To_Date, setTo_Date] = useState();

  // 🧾 خروجی به PDF

  const exportToPDF = () => {
    if (!data || data.length === 0) {
      enqueueSnackbar("No data to export", { variant: "warning" });
      return;
    }
  
    const doc = new jsPDF("l", "pt", "a4");
  
    doc.setFontSize(12);
    doc.text("Global Report", 40, 30);
  
    doc.setFontSize(10);
    doc.text(
      `From: ${From_Date.format("YYYY-MM-DD")}  To: ${To_Date.format("YYYY-MM-DD")}`,
      40,
      45
    );
  
    // ----------------- 19 ستون تقسیم به دو ردیف ------------------
    const headersRow1 = [
      "Name", "Passport", "Room", "type","Reserv Name",
      "Reserv", "Checkin", "Checkout",
      "Night No" ,"Price Night", `Room Price ${DolerLary}`, `Breakfast ${DolerLary}`, `Extra ${DolerLary}`,`Other ${DolerLary}`, `Sum ${DolerLary}`,
      `Discount ${DolerLary}`, `pre payment ${DolerLary}`, `Total ${DolerLary}`,
    ]; 
  
    // const headersRow2 = [
    //   "Room Price", "Breakfast", "Extra", "Other", "Sum",
    //   "Discount", "Net Pay", "Total", "Rate", "Total Price₾"
    // ]; // 10 ستون
  
    // const head = [headersRow1, headersRow2];
    const head = [headersRow1];
    // ----------------- دیتا دو ردیفی مطابق هدر ------------------
    const body = [];
  
    data.forEach((d) => {
      const row1 = [
        d.Name || "",
        d.Pass_No || "",
       d.Room_Number || "",
        d.Prese_Name || "",  
        d.Reserv_Name || "",  
        d.Reserv_Date || "",
        d.Reserv_Checkindate || "",
        d.Reserv_Checkoutdate || "",
        d.Night_No || "",
        d.Reserv_Base_Price || "",
        d.Reserv_Price || "",
        d.Reserv_BreakfastAmount || "",
        d.Reserv_ExtraAmount || "",
        d.Reserv_Other || "",
        d.Reserv_Account || "",
        d.Reserv_Discount || "",
        d.Reserv_prepayment || "",
        d.Reserv_Total || "",
        // d.Reserv_Rate || "",
        // d.Reserv_Gel || "",
      ];
  
      body.push(row1);
      // body.push(row2);
    });
  
    // --------------------------------------------------------------
    autoTable(doc, {
      head,
      body,
      startY: 60,
      theme: "striped",
      headStyles: { fillColor: [22, 160, 133], textColor: 255 },
      styles: { fontSize: 8, cellPadding: 3 },
       // ✨ تعیین عرض ستون‌ها
  columnStyles: {
    0: { cellWidth: 100 },   // Name
    1: { cellWidth: 80 },   // Passport

    2: { cellWidth: 40 },   // Room
    3: { cellWidth: 40 },   // type
    4: { cellWidth: 40 },   // Reserv Name
    5: { cellWidth: 50 },   // Reserv
    6: { cellWidth: 50 },   // Checkin
    7: { cellWidth: 50 },   // Checkout
    8: { cellWidth: 30 },   // Night No
    9: { cellWidth: 40 },   // Price Night
    10: { cellWidth: 40 },  // Room Price
    11: { cellWidth: 42 },  // Breakfast
    12: { cellWidth: 25 },  // Extra
    13: { cellWidth: 25 },  // Other
    14: { cellWidth: 30 },  // Sum
    15: { cellWidth: 40 },  // Discount
    16: { cellWidth: 40 },  // prepayment
    17: { cellWidth: 30 },  // Total $
    // 18: { cellWidth: 25 },  // Rate
    // 19: { cellWidth: 60 },  // Total ₾
  },
    // ✨ فعال کردن خطوط عمودی و افقی برای جدول و سلول‌ها

    // ✨ فعال کردن خطوط عمودی و افقی برای جدول و سلول‌ها
    tableLineWidth: 0.5, // عرض خط جدول
    tableLineColor: [0, 0, 0], // رنگ خط جدول (مشکی)
    cellLineWidth: 0.2, // عرض خطوط درون سلول‌ها
    cellLineColor: [0, 0, 0], // رنگ خطوط درون سلول‌ها (مشکی)

    // ✨ فعال کردن خطوط افقی و عمودی بین سلول‌ها
    lineWidth: 0.2, // عرض خطوط جداکننده بین سلول‌ها
    lineColor: [0, 0, 0], // رنگ خطوط جداکننده (مشکی)

    // ✨ نمایش هدر در هر صفحه
    showHead: "everyPage",
    margin: { top: 60, left: 10, right: 10, bottom: 40 },
    });
  
    doc.save(`GlobalReport_${new Date().toISOString()}.pdf`);
  };
  

  
  const exportToExcel = async () => {
    const headers =[
      "Name", "Passport", "Room", "type","Reserv Name",
      "Reserv", "Checkin", "Checkout", "Night No",
      `Price/Night ${DolerLary}`, `Room Price ${DolerLary}`, `Breakfast ${DolerLary}`, `Extra ${DolerLary}`, `Other ${DolerLary}`, `Sum ${DolerLary}`,
      `Discount ${DolerLary}`, `prepayment ${DolerLary}`, `Total ${DolerLary}`
    ]; 
  
    // 2) تعیین اینکه از کدام فیلدها مقدار بگیریم
    const fields = [
      "Name", "Pass_No",  "Room_Number", "Prese_Name","Reserv_Name",
      "Reserv_Date", "Reserv_Checkindate", "Reserv_Checkoutdate","Night_No",
      "Reserv_Base_Price", "Reserv_Price", "Reserv_BreakfastAmount",
      "Reserv_ExtraAmount","Reserv_Other","Reserv_Account",
      "Reserv_Discount","Reserv_prepayment","Reserv_Total"
    ];
    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet("Report");
  
    // ستون‌ها و عرض‌ها
    sheet.columns = headers.map(h => ({ header: h, width: Math.max(12, h.length + 4) }));
  
    // header style
    sheet.getRow(1).font = { bold: true };
    sheet.getRow(1).alignment = { vertical: "middle", horizontal: "center" };
    sheet.getRow(1).fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFD9E1F2" } // ARGB
    };
    sheet.getRow(1).border = {
      top: { style: "thin" }, left: { style: "thin" },
      bottom: { style: "thin" }, right: { style: "thin" }
    };
  
    // داده‌ها
    data.forEach(item => {
      const row = fields.map(f => item[f] ?? "");
        sheet.addRow(row);
    });

    // فریز کردن هدر
    sheet.views = [{ state: "frozen", ySplit: 1 }];
  
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: "application/octet-stream" });
    saveAs(blob, `GlobalReport_${new Date().toISOString()}.xlsx`);
  };
  
  // 🖨 چاپ مستقیم
  const handlePrint = useReactToPrint({
    content: () => gridRef.current,
    documentTitle: "Global Report",
  });
  const totalPrice = data?.reduce((acc, row) => acc + (row.Reserv_Total || 0), 0) || 0;

    return (
      
      <Box sx={{ p: 12 }}>
      {/* 🔷 فیلترها و کنترل‌ها */}
      <Paper
        elevation={3}
        sx={{
          borderRadius: 2,
          p: 2,
          mb: 3,
                 backgroundColor: "#fdfdfd",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          gap: 2,
        }}
      >
        {/* <Typography
          variant="h6"
          sx={{ mb: 1, color: "#2c3e50", fontWeight: "bold" }}
        >
          Global Report Filter
        </Typography> */}
  
        <Stack
  direction="row"
  spacing={1} // ← فاصله کل Stack کمتر شد
  alignItems="center"
  height={30}
  
  sx={{ mb: 1, overflowX: "auto" }}
>

  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
    <label style={{width:'40px',fontSize:'12px'}}>From:</label>
    <DatePicker
      value={From_Date}
      onChange={setFrom_Date}
      style={{ height: "35px",width:'80px'}}
    />
  </Box>

  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 ,marginLeft:'5px'}}>
    <label style={{width:'40px',fontSize:'12px'}} > To:</label>
    <DatePicker
      value={To_Date}
      onChange={setTo_Date}
      style={{ height: "35px" ,width:'80px'}}
    />
  </Box>
  {/* <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                <label for="PassportNo" style={{width:'90px',fontSize:'12px'}}>Room NO</label>
                    <Select style={{ width: '130px', height: '40px', marginLeft: '-10px', backgroundColor: "rgb(225, 225, 198)" }}
                          labelId="demo-multiple-name-label"
                          id="demo-multiple-name"
                          disabled={false}
                          value={Room_No}
                          onChange={changeRoom_No}
                          input={<OutlinedInput label="Name" />}
                      //   MenuProps={MenuProps}
                        >
                        <MenuItem value="0">
                          <em>None</em>
                        </MenuItem>
                        {RoomTypeData.map((dat) => (
                          <MenuItem key={dat.Room_No} value={dat.Room_No}>{dat.Room_No}</MenuItem>
                        ))}

              </Select>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
  <label style={{width:'60px',fontSize:'12px'}}> Type:</label>
  <Select
    value={prese_Id}
    onChange={(e) => setprese_Id(e.target.value)}
    input={<OutlinedInput />}
    sx={{ width: 90, backgroundColor: "#fff" ,height:'30px'}}
  >
    <MenuItem value="0">
      <em>None</em>
    </MenuItem>
    {PresentTypeData.map((dat) => (
      <MenuItem key={dat.value} value={dat.value}>
        {dat.label}
      </MenuItem>
    ))}
  </Select>
</Box>
<Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
  <label style={{width:'60px',fontSize:'12px'}}>Reserv Type:</label>
  <Select
    value={Reserv_Type}
    onChange={(e) => setReserv_Type(e.target.value)}
    input={<OutlinedInput />}
    sx={{ width: 90, backgroundColor: "#fff" ,height:'30px'}}
  >
    <MenuItem value="0">
      <em>All</em>
    </MenuItem>
    {Reserv_TypeData.map((dat) => (
      <MenuItem key={dat.Reserv_Type} value={dat.Reserv_Type}>
        {dat.Reserv_Name}
      </MenuItem>
    ))}
  </Select>
</Box>
<label for="" style={{marginLeft:'0px' ,width:'90px',fontSize:'12px'}}> Last Name </label> 
                    <input
                        type="text"
                        id="Prese_Name"
                        disabled={false}
                        value={Last_Name}
                        onChange={(e) =>setLast_Name(e.target.value) }
                        // //placeholder="Enter First Name"
                        required
                        style={{width:'100px'}}
                    /> */}
  <Chip
    label="Run Report"
    onClick={getData}
    color="primary"
    sx={{
      cursor: "pointer",
      fontWeight: "bold",
      backgroundColor: "#16a085",
      color: "#fff",
    }}
  />
  {/* <Chip
    label="Run ₾"
    onClick={getDataLary}
    color="primary"
    sx={{
      cursor: "pointer",
      fontWeight: "bold",
      backgroundColor: "#16a085",
      color: "#fff",
    }}
  /> */}

<Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
  </Box>
  </Stack>
      </Paper>

      {/* 🔶 جدول داده‌ها */}
      <Paper
  elevation={4}
  sx={{
    marginTop: -2,
    height: 410,
    borderRadius: 3,
    "& .MuiDataGrid-root": {
      border: "none",
      fontFamily: "Roboto, Vazirmatn, sans-serif",
    },
    "& .MuiDataGrid-columnHeaders": {
      backgroundColor: "#16a085",
    },
    "& .MuiDataGrid-columnHeader": {
      backgroundColor: "#16a085 !important",
      color: "#fff !important",
      fontWeight: "bold",
      fontSize: "12px",
      textAlign: "center",
      borderRight: "1px solid rgba(255,255,255,0.2)",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      whiteSpace: "normal",
      lineHeight: "1.4em",
    },
    "& .MuiDataGrid-cell": {
     color: "#2c3e50",
      fontSize: "12px",
      fontWeight: "bold",
      borderBottom: "1px solid #ecf0f1",
    },
    // فقط برای ردیف جمع، سایز فونت بزرگ‌تر شود
    "& .MuiDataGrid-row.sum-row .MuiDataGrid-cell": {
      fontSize: "16px", // فقط سایز فونت بزرگ‌تر
      color:'blue',
    },
    "& .cancel-cell": {
      backgroundColor: "#e74c3c !important",
      color: "#fff",
      fontWeight: "bold",
    },
  }}
>
  <DataGrid
    rows={data} // داده‌ها + ردیف جمع
    columns={columns}
    disableColumnMenu={false}
    disableColumnSelector
    disableDensitySelector
    hideFooterSelectedRowCount
    filterMode="client"
    disableColumnFilter={false}
    getRowClassName={(params) => params.id === sumRow.id ? "sum-row" : ""}
    sx={{
      "& .MuiDataGrid-row.sum-row .MuiDataGrid-cell": {
        fontSize: "16px", // فونت بزرگ‌تر
        color:'yellow',
      },
    }}
    slotProps={{
      toolbar: {
        showQuickFilter: true,
        quickFilterProps: { debounceMs: 500 },
      },
    }}
    hideFooter
    rowHeight={32}
    headerHeight={36}
    pagination={false}
    autoHeight={false}
  />
</Paper>


      {/* 🔶 جدول جمع ها */}

    </Box>
    );

})
export default BookingReport;